import $ from 'jquery';
import React from 'react';
import {Comment, CommentForm} from './Comments.js';

class CommentsArea extends React.Component {
  state = {
    commentable: false,
    comments: null,
    commentsDisallowed: false,
    contextActions: {},
    earliest: null,
    lo: null,
    newComment: '',
    smsVerificationRequired: false,
    submitting: false,
  };

  componentDidMount() {
    if (this.props.source) {
      $.getJSON(this.props.source).done(data => {
        this.setState({
          commentable: data.commentable,
          comments: data.comments,
          commentsDisallowed: data.comments_disallowed,
          earliest: data.earliest,
          lo: data.comments.length > 0 ? data.comments[data.comments.length - 1].created_at : null,
          smsVerificationRequired: data.sms_verification_required,
        });
      });
    }
  }

  _deleteComment = (comment) => {
    if (!confirm('Are you sure?')) {
      return;
    }
    $.deleteJSON(comment._links.self.href).done(() => {
      const i = this.state.comments.indexOf(comment);
      if (i >= 0) {
        const comments = this.state.comments.slice(0);
        comments.splice(i, 1);
        this.setState({comments: comments});
      }
    });
  };

  _fetchContextActions = (url, key) => {
    $.getJSON(url).done(data => {
      this.setState({
        contextActions: {
          ...this.state.contextActions,
          [key]: data._links,
        },
      });
    });
  };

  _fetchPrevious = (event) => {
    if (!this.state.lo) {
      return;
    }
    $.getJSON(this.props.source, {before: this.state.lo}).done(data => {
      const comments = this.state.comments.concat(data.comments);
      this.setState({
        comments: comments,
        lo: data.comments.length > 0 ? data.comments[data.comments.length - 1].created_at : this.state.lo,
      });
    });
  };

  _newCommentChanged = (event) => {
    this.setState({newComment: event.target.value});
  };

  _submitContent = (event) => {
    event.preventDefault();
    if (this.state.submitting) {
      return;
    }
    if (!this.state.newComment.trim()) {
      return;
    }
    this.setState({submitting: true});
    $.post(this.props.source, {content: this.state.newComment}).done(data => {
      this.setState({
        comments: [data].concat(this.state.comments),
        newComment: '',
        submitting: false,
      });
    }).fail(jqXhr => {
      this.setState({
        submitting: false,
      });
    });
  };

  render() {
    if (!this.props.source) {
      return null;
    }
    const {commentable, comments, commentsDisallowed, contextActions, earliest, lo} = this.state;
    if (!comments) {
      return (
        <div>
          <div className="loading-gif"></div>
        </div>
      );
    }
    const hasPrevious = earliest && lo && (earliest < lo);
    if (comments.length === 0 && !commentable && !hasPrevious && !commentsDisallowed) {
      return null;
    }
    return (
      <div className="CommentList">
        {
          commentable ? (
            <CommentForm
              smsVerificationRequired={this.state.smsVerificationRequired}
              submitting={this.state.submitting}
              value={this.state.newComment}
              onChange={this._newCommentChanged}
              onSubmit={this._submitContent} />
          ): null
        }
        {
          comments.map(comment => {
            return (
              <Comment
                key={comment.id}
                comment={comment}
                contextActions={contextActions[comment._links.self.href]}
                onDelete={this._deleteComment}
                onFetchContextActions={this._fetchContextActions}
                />
            );
          })
        }
        {
          hasPrevious ? (
            <div className="Comment">
              <a onClick={this._fetchPrevious}>
                View Previous Comments
              </a>
            </div>
          ): null
        }
        {
          commentsDisallowed ? (
            <div className="text-center help-block">
              Comments have been disabled.
            </div>
          ): null
        }
      </div>
    );
  }
}

export default CommentsArea;
